"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const home_1 = __importDefault(require("~pages/home"));
const terms_of_service_1 = __importDefault(require("~pages/legal/terms-of-service"));
const privacy_policy_1 = __importDefault(require("~pages/legal/privacy-policy"));
const proof_of_value_agreement_1 = __importDefault(require("~pages/legal/proof-of-value-agreement"));
const service_agreement_1 = __importDefault(require("~pages/legal/service-agreement"));
const common_1 = __importDefault(require("~server/hydrate/common"));
const not_found_1 = __importDefault(require("~server/hydrate/not-found"));
const unrecognised_email_activity_1 = __importDefault(require("~server/hydrate/unrecognised-email-activity"));
const not_found_2 = __importDefault(require("~pages/not-found"));
const enterprise_quote_portal_1 = __importDefault(require("~pages/enterprise-quote-portal"));
const unrecognised_email_activity_2 = __importDefault(require("~pages/unrecognised-email-activity"));
const security_and_compliance_overview_1 = __importDefault(require("~pages/legal/security-and-compliance-overview"));
const mssps_1 = __importDefault(require("~pages/mssps"));
const routes = [
    {
        path: '/',
        exact: true,
        component: home_1.default,
        hydrate: common_1.default,
        title: '',
        description: 'PhishTool gives human analysts the power to reverse engineer phishing emails, to better defend against them. Try PhishTool Community for free.',
    },
    {
        path: '/mssps',
        exact: true,
        component: mssps_1.default,
        hydrate: common_1.default,
        title: 'MSSPs',
        description: 'Investigate, respond, and report on phishing threats across multiple MSSP clients, all from one central, white-label capable platform. PhishTool Enterprise gives Managed Service Providers the speed, clarity, and control needed to deliver email security as a service at scale.',
    },
    {
        path: '/contact',
        exact: true,
        component: () => (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: "/#contact" }),
        hydrate: common_1.default,
    },
    {
        path: '/enterprise-quote-portal/:token',
        exact: true,
        component: enterprise_quote_portal_1.default,
        hydrate: common_1.default,
        title: 'Enterprise Quote Portal',
        description: '',
    },
    {
        path: '/unrecognised-email-activity/:token',
        exact: true,
        component: unrecognised_email_activity_2.default,
        hydrate: unrecognised_email_activity_1.default,
        title: 'Unrecognised Email Activity',
        description: '',
    },
    {
        path: '/terms-of-service',
        exact: true,
        component: terms_of_service_1.default,
        hydrate: common_1.default,
        title: 'Terms of Service',
        description: '',
    },
    {
        path: '/privacy-policy',
        exact: true,
        component: privacy_policy_1.default,
        hydrate: common_1.default,
        title: 'Privacy Policy',
        description: '',
    },
    {
        path: '/proof-of-value-agreement',
        exact: true,
        component: proof_of_value_agreement_1.default,
        hydrate: common_1.default,
        title: 'Proof of Value Agreement',
        description: '',
    },
    {
        path: '/service-agreement',
        exact: true,
        component: service_agreement_1.default,
        hydrate: common_1.default,
        title: 'Service Agreement',
        description: '',
    },
    {
        path: '/security-and-compliance-overview',
        exact: true,
        component: security_and_compliance_overview_1.default,
        hydrate: common_1.default,
        title: 'Security and Compliance Overview',
        description: '',
    },
    {
        path: '*',
        component: not_found_2.default,
        hydrate: not_found_1.default,
    },
];
exports.default = routes;
